// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuFilterClauseCombinator{--saltButton-height:calc(var(--salt-spacing-400));padding:0 4px;font-size:9px}.vuuFilterClauseCombinator:focus{background-color:var(--vuu-color-gray-50);color:#fff}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
